import React from 'react'
import { Link } from 'react-router-dom'

const SignUpOtp = () => {
  return (
      <div className='w-full '>
        <form action="" className='w-full flex flex-col gap-2 '>
            <span className='text-base font-bold text-[#abc7b9]'>Phone Number</span>
            <input type="text" placeholder='Enter the phone number' className='w-full border border-[#22BEFF33] outline-0 bg-[#143E55] text-[#abc7b9] p-3 px-4 rounded-md'/>
            <button className='w-full bg-[#22BEFF] p-3 mt-4 rounded-md cursor-pointer text-sm font-bold'>Request OTP</button>
            <p className='mt-4 text-base font-medium text-[#abc7b9] text-center'>Already have an account? <Link to="/signin" className='text-[#22BEFF]'>Sign in</Link></p>

        </form>

    </div>
  )
}

export default SignUpOtp